import EasterPromoBYD from "../../../images/promo/easter26/ScarcityBanner_BYD.png";
import EasterPromoMobileBYD from "../../../images/promo/easter26/ScarcityBannerMobile_BYD.png";
import EasterPromoMitsubishi from "../../../images/promo/easter26/ScarcityBanner_Mitsubishi.png";
import EasterPromoMobileMitsubishi from "../../../images/promo/easter26/ScarcityBannerMobile_Mitsubishi.png";
import EasterPromoPolestar from "../../../images/promo/easter26/ScarcityBanner_Polestar.png";
import EasterPromoMobilePolestar from "../../../images/promo/easter26/ScarcityBannerMobile_Polestar.png";
import EasterPromoWolks from "../../../images/promo/easter26/ScarcityBanner_Volkswagen.png";
import EasterPromoMobileWolks from "../../../images/promo/easter26/ScarcityBannerMobile_Volkswagen.png";

const dataSlider = (hidePartnered) => [
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: false,
        isPartner: true,
        hideBanner: hidePartnered, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "",
        image: "",
        imageMobile: "",
    },
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: true,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "",
        image: EasterPromoBYD,
        imageMobile: EasterPromoMobileBYD,
    },
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: true,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "",
        image: EasterPromoPolestar,
        imageMobile: EasterPromoMobilePolestar,
    },
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: true,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "",
        image: EasterPromoMitsubishi,
        imageMobile: EasterPromoMobileMitsubishi,
    },
    {
        isTextImage: false,
        isTextImageNoPrice: false,
        isFullImage: true,
        isPartner: false,
        hideBanner: false, // true will remove this section from the slider
        titleBadge: "",
        vehicleTitle: "",
        vehicleSubTitle: "",
        priceDollar: "",
        priceCents: "",
        period: "",
        disclaimerText: "",
        image: EasterPromoWolks,
        imageMobile: EasterPromoMobileWolks,
    },
    // {
    //     isTextImage: true,
    //     isTextImageNoPrice: false,
    //     isFullImage: false,
    //     isPartner: false,
    //     hideBanner: false, // true will remove this section from the slider
    //     titleBadge: "New Offer",
    //     vehicleTitle: "MG All EV Models",
    //     vehicleSubTitle:
    //         "Free 7kW Charge Hub for orders placed between 1st March to 31st March 2026.",
    //     priceDollar: "",
    //     priceCents: "",
    //     period: "",
    //     disclaimerText:
    //         "* Offer available on new vehicles, and to eligible customers who order and take delivery within the promotional period. Terms and eligibility criteria apply.",
    //     termsLinkUrl: "",
    //     image: PromoMGIM5,
    //     imageMobile: PromoMGIM5Mobile,
    // },
    // {
    //     isTextImage: true,
    //     isTextImageNoPrice: false,
    //     isFullImage: false,
    //     isPartner: false,
    //     hideBanner: false, // true will remove this section from the slider
    //     titleBadge: "Customer Favourites",
    //     vehicleTitle: "Tesla Model Y RWD",
    //     vehicleSubTitle: "",
    //     priceDollar: "216",
    //     priceCents: "",
    //     period: "weekly*",
    //     disclaimerText:
    //         "* Weekly price assumes a 5 year lease, a driver based in NSW with an annual pre-tax salary of $100,000, and car running costs based on 15,000km driven per year.",
    //     termsLinkUrl: "",
    //     image: PromoTeslaY,
    //     imageMobile: PromoTeslaYMobile,
    // },
];

export default dataSlider;
